import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { SearchResultsPage } from './pages/SearchResultsPage';
import { AboutPage } from './pages/AboutPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { PartnerPage } from './pages/PartnerPage';
import { ReactionsProvider } from './contexts/ReactionsContext';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <ReactionsProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/search" element={<SearchResultsPage data-id="element-7" />} data-id="element-6" />
          <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-11" />} data-id="element-10" />
          <Route path="/terms" element={<TermsPage data-id="element-13" />} data-id="element-12" />
          <Route path="/partner" element={<PartnerPage data-id="element-15" />} data-id="element-14" />
        </Routes>
      </BrowserRouter>
    </ReactionsProvider>;
}